import LoadingButton from "@material-ui/lab/LoadingButton";
import { CssBaseline, TextField, Grid, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../../res/manageit-logo-blue.svg";
import dtechLogo from "../../res/logo.png";
import { useMutation } from "react-query";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { login } from "../../api";
import { useSnackbar } from "notistack";
import { getFormPayload } from "../../utils";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    marginBottom: theme.spacing(1),
  },
  alert: {
    width: "100%",
  },
  form: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  line: {
    marginTop: 30,
    width: "100%",
    border: "none",
    borderBottom: "1px solid #c4c4c4",
  },
}));

export default function Login() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const {
    mutate: doLogin,
    isLoading,
    error,
  } = useMutation(login, {
    onSuccess: ({ tfa_token }) => {
      window.localStorage.setItem("tfa_token", tfa_token);
      history.push("/tfa");
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const logIn = (e) => {
    e.preventDefault();
    const data = getFormPayload(e.currentTarget);
    doLogin(data);
  };

  const validationErrors = error && error.errors;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img
          alt="manageIT logo"
          width={160}
          src={logo}
          className={classes.logo}
        />
        <form className={classes.form} onSubmit={logIn} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            error={!!validationErrors?.email}
            helperText={validationErrors?.email}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            error={!!validationErrors?.password}
            helperText={validationErrors?.password}
          />
          <LoadingButton
            loading={isLoading}
            loadingPosition="start"
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Log in
          </LoadingButton>
          <Grid container>
            <Grid item xs>
              <Link to="/forgot">
                <Typography variant="body2">Forgot password?</Typography>
              </Link>
            </Grid>
          </Grid>
        </form>
        <hr className={classes.line} />
        <img src={dtechLogo} width={80} alt="D-Tech logo" />
        <Typography variant="caption">© D-Tech International Ltd</Typography>
      </div>
    </Container>
  );
}
